function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/removerowcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import TableWalker from '../tablewalker';
import { updateNumericAttribute } from './utils';
import { getSelectionAffectedTableCells } from '../utils';
/**
 * The remove row command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'removeTableRow'` editor command.
 *
 * To remove the row containing the selected cell, execute the command:
 *
 *		editor.execute( 'removeTableRow' );
 *
 * @extends module:core/command~Command
 */

var RemoveRowCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(RemoveRowCommand, _Command);

  function RemoveRowCommand() {
    _classCallCheck(this, RemoveRowCommand);

    return _possibleConstructorReturn(this, _getPrototypeOf(RemoveRowCommand).apply(this, arguments));
  }

  _createClass(RemoveRowCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var selectedCells = getSelectionAffectedTableCells(this.editor.model.document.selection);
      var firstCell = selectedCells[0];

      if (firstCell) {
        var table = firstCell.parent.parent;
        var tableRowCount = this.editor.plugins.get('TableUtils').getRows(table);

        var tableMap = _toConsumableArray(new TableWalker(table));

        var rowIndexes = tableMap.filter(function (entry) {
          return selectedCells.includes(entry.cell);
        }).map(function (el) {
          return el.row;
        });
        var minRowIndex = rowIndexes[0];
        var maxRowIndex = rowIndexes[rowIndexes.length - 1];
        this.isEnabled = maxRowIndex - minRowIndex < tableRowCount - 1;
      } else {
        this.isEnabled = false;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this = this;

      var referenceCells = getSelectionAffectedTableCells(this.editor.model.document.selection);
      var removedRowIndexes = getRowIndexes(referenceCells);
      var firstCell = referenceCells[0];
      var table = firstCell.parent.parent;

      var tableMap = _toConsumableArray(new TableWalker(table, {
        endRow: removedRowIndexes.last
      }));

      var batch = this.editor.model.createBatch();
      var columnIndexToFocus = getColumnIndexToFocus(tableMap, firstCell); // Doing multiple model.enqueueChange() calls, to get around ckeditor/ckeditor5#6391.
      // Ideally we want to do this in a single model.change() block.

      this.editor.model.enqueueChange(batch, function (writer) {
        // This prevents the "model-selection-range-intersects" error, caused by removing row selected cells.
        writer.setSelection(writer.createSelection(table, 'on'));
      });
      var cellToFocus;

      var _loop = function _loop(i) {
        _this.editor.model.enqueueChange(batch, function (writer) {
          var removedRowIndex = i;

          _this._removeRow(removedRowIndex, table, writer, tableMap);

          cellToFocus = getCellToFocus(table, removedRowIndex, columnIndexToFocus);
        });
      };

      for (var i = removedRowIndexes.last; i >= removedRowIndexes.first; i--) {
        _loop(i);
      }

      this.editor.model.enqueueChange(batch, function (writer) {
        writer.setSelection(writer.createPositionAt(cellToFocus, 0));
      });
    }
    /**
     * Removes a row from the given `table`.
     *
     * @private
     * @param {Number} removedRowIndex Index of the row that should be removed.
     * @param {module:engine/model/element~Element} table
     * @param {module:engine/model/writer~Writer} writer
     * @param {module:engine/model/element~Element[]} tableMap Table map retrieved from {@link module:table/tablewalker~TableWalker}.
     */

  }, {
    key: "_removeRow",
    value: function _removeRow(removedRowIndex, table, writer, tableMap) {
      var cellsToMove = new Map();
      var tableRow = table.getChild(removedRowIndex);
      var headingRows = table.getAttribute('headingRows') || 0;

      if (headingRows && removedRowIndex < headingRows) {
        updateNumericAttribute('headingRows', headingRows - 1, table, writer, 0);
      } // Get cells from removed row that are spanned over multiple rows.


      tableMap.filter(function (_ref) {
        var row = _ref.row,
            rowspan = _ref.rowspan;
        return row === removedRowIndex && rowspan > 1;
      }).forEach(function (_ref2) {
        var column = _ref2.column,
            cell = _ref2.cell,
            rowspan = _ref2.rowspan;
        return cellsToMove.set(column, {
          cell: cell,
          rowspanToSet: rowspan - 1
        });
      }); // Reduce rowspan on cells that are above removed row and overlaps removed row.

      tableMap.filter(function (_ref3) {
        var row = _ref3.row,
            rowspan = _ref3.rowspan;
        return row <= removedRowIndex - 1 && row + rowspan > removedRowIndex;
      }).forEach(function (_ref4) {
        var cell = _ref4.cell,
            rowspan = _ref4.rowspan;
        return updateNumericAttribute('rowspan', rowspan - 1, cell, writer);
      }); // Move cells to another row.

      var targetRow = removedRowIndex + 1;
      var tableWalker = new TableWalker(table, {
        includeSpanned: true,
        startRow: targetRow,
        endRow: targetRow
      });
      var previousCell;

      for (var _i = 0, _arr = _toConsumableArray(tableWalker); _i < _arr.length; _i++) {
        var _arr$_i = _arr[_i],
            row = _arr$_i.row,
            column = _arr$_i.column,
            cell = _arr$_i.cell;

        if (cellsToMove.has(column)) {
          var _cellsToMove$get = cellsToMove.get(column),
              cellToMove = _cellsToMove$get.cell,
              rowspanToSet = _cellsToMove$get.rowspanToSet;

          var targetPosition = previousCell ? writer.createPositionAfter(previousCell) : writer.createPositionAt(table.getChild(row), 0);
          writer.move(writer.createRangeOn(cellToMove), targetPosition);
          updateNumericAttribute('rowspan', rowspanToSet, cellToMove, writer);
          previousCell = cellToMove;
        } else {
          previousCell = cell;
        }
      }

      writer.remove(tableRow);
    }
  }]);

  return RemoveRowCommand;
}(Command); // Returns a helper object with first and last row index contained in given `referenceCells`.


export { RemoveRowCommand as default };

function getRowIndexes(referenceCells) {
  var allIndexesSorted = referenceCells.map(function (cell) {
    return cell.parent.index;
  }).sort();
  return {
    first: allIndexesSorted[0],
    last: allIndexesSorted[allIndexesSorted.length - 1]
  };
} // Returns a cell that should be focused before removing the row, belonging to the same column as the currently focused cell.
// * If the row was not the last one, the cell to focus will be in the row that followed it (before removal).
// * If the row was the last one, the cell to focus will be in the row that preceded it (before removal).


function getCellToFocus(table, removedRowIndex, columnToFocus) {
  var row = table.getChild(removedRowIndex) || table.getChild(table.childCount - 1); // Default to first table cell.

  var cellToFocus = row.getChild(0);
  var column = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = row.getChildren()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var tableCell = _step.value;

      if (column > columnToFocus) {
        return cellToFocus;
      }

      cellToFocus = tableCell;
      column += parseInt(tableCell.getAttribute('colspan') || 1);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return cellToFocus;
} // Returns the index of column that should be focused after rows are removed.


function getColumnIndexToFocus(tableMap, firstCell) {
  var firstCellData = tableMap.find(function (value) {
    return value.cell === firstCell;
  });
  return firstCellData.column;
}